import { Options } from '@sentry/types';
import { Provider, ProviderConfig, SentryClient } from './types';

export default class SentryProvider implements Provider {
  private sentryClient : SentryClient;

  constructor(config: ProviderConfig, sentryClient: SentryClient) {
    this.sentryClient = sentryClient;
    this.init(config);
  }

  init = (config: ProviderConfig) => {
    this.sentryClient.init(this.getSentryConfig(config));
  };

  log = (message: string) => {
    this.sentryClient.captureMessage(message);
  };

  logException = (exception: Error) => {
    this.sentryClient.captureException(exception);
  };

  close = async (timeout: number): Promise<void> => {
    await this.sentryClient.flush(timeout);
  };

  private getSentryConfig(config: ProviderConfig): Options {
    return {
      dsn: config.url,
      environment: config.environment,
    };
  }
}
